import { roles } from 'src/constants/roles';
import { Option } from 'src/components/Admin/Modals/FormElements/type';

export const rolesFilterOptions: Option[] = roles.map((role) => ({
  value: role.name,
  label: role.display,
}));
